import { Box, Icon, IconButton } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import Navbar from '../../../components/core/Navbar'
import { LuMoon, LuSun } from 'react-icons/lu'
import ScrollToTopButton from '../../../components/core/ScrollToTopButton'
import { useColorMode } from '../../../components/ui/color-mode'
import LandingCoding from './LandingCoding'
import ServicesCoding from './ServicesCoding'
import StartUp from './StartUp'
import Footer from '../../Home/Components/Footer'

const Coding = () => {


  const { colorMode, toggleColorMode } = useColorMode()
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <Box>
        <Navbar globalColor='red'/>
        <LandingCoding/>
        <ServicesCoding/>
        <StartUp/>
        <Footer globalColor={'blue'} footerImage={require('../../../assets/coding/footerImage.png')}/>

        {/* floating button */}
        <IconButton position={'fixed'} bottom={4} right={4} shadow={'xl'} zIndex={1000} onClick={toggleColorMode} variant={'solid'} rounded={'full'}>
            <Icon boxSize={4}>
              {colorMode === 'light' ? <LuMoon /> : <LuSun />}
            </Icon>
          </IconButton>
        <ScrollToTopButton />
    </Box>
  )
}

export default Coding